/* eslint-disable no-console */
var JUNO_WARNING_IGNORE_KEY = '__JUNO_WARNING_IGNORE__';
// * use that way to avoid that code be exist in production code base
/**
 * config global setting
 *
 * ```ts
 * configure({
 *   warning: false
 * })
 * ```
 * ## WARNING related method and  only work in `development mode`
 *
 * `WARNING_IGNORE`:  only work in `development mode`
 * `WARNING_FUNCTION` only work in `development mode`
 */
var rcConfiguration = {};
if (process.env.NODE_ENV !== 'production') {
    var RcConfig = /** @class */ (function () {
        function RcConfig() {
            var _a;
            this._WARNING_IGNORE = false;
            this._WARNING_FUNCTION = function (message, options) {
                console[(options === null || options === void 0 ? void 0 : options.level) || 'warn'](message);
            };
            if (typeof window !== 'undefined') {
                // SSR support
                // * get value once when init
                this._WARNING_IGNORE =
                    ((_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.getItem(JUNO_WARNING_IGNORE_KEY)) === 'true';
                // * also provide user to set variable from window
                window.__JUNO__ = this;
            }
        }
        Object.defineProperty(RcConfig.prototype, "WARNING_IGNORE", {
            get: function () {
                return this._WARNING_IGNORE;
            },
            set: function (value) {
                var _a;
                if (value) {
                    console.log('---------------- [Juno] ----------------');
                    console.log("Don't recommended you close it, we should avoid use any deprecated props or methods.");
                    console.log('---------------- [Juno] ----------------');
                }
                this._WARNING_IGNORE = !!value;
                (_a = window === null || window === void 0 ? void 0 : window.localStorage) === null || _a === void 0 ? void 0 : _a.setItem(JUNO_WARNING_IGNORE_KEY, "" + this._WARNING_IGNORE);
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(RcConfig.prototype, "WARNING_FUNCTION", {
            get: function () {
                return this._WARNING_FUNCTION;
            },
            set: function (func) {
                if (typeof func === 'function') {
                    this._WARNING_FUNCTION = func;
                }
                else {
                    console.warn('[Juno] config warningFunction is not a function.');
                }
            },
            enumerable: true,
            configurable: true
        });
        return RcConfig;
    }());
    rcConfiguration = new RcConfig();
}
/**
 * set config with Juno
 *
 * ## WARNING method only work in `development mode`
 */
export var configure = function (options) {
    if (process.env.NODE_ENV !== 'production') {
        var warning = options.warning, warningFunction = options.warningFunction;
        if (warning !== undefined) {
            rcConfiguration.WARNING_IGNORE = !warning;
        }
        if (warningFunction !== undefined) {
            rcConfiguration.WARNING_FUNCTION = warningFunction;
        }
    }
};
export { rcConfiguration };
